import request from '@/utils/request2'

// 获取待考试课程数/待学习课程数/待评价课程数接口
export function getPxTotal (params) {
  return request({
    url: '/api/wxpx/getPxTotal',
    method: 'get',
    params: params
  })
}

// 获取待考试课程列表接口
export function getTestCourseList (params) {
  return request({
    url: '/api/wxpx/getTestCourseList',
    method: 'get',
    params: params
  })
}

// 获取某个课程考试的汇总信息接口
export function getCourseTestTotal (params) {
  return request({
    url: '/api/wxpx/getCourseTestTotal',
    method: 'get',
    params: params
  })
}

// 生成当前用户当前课程考试试卷信息（并返回试题明细和上次中断序号信息）
export function createUserTestInfo (params) {
  return request({
    url: '/api/wxpx/createUserTestInfo',
    method: 'get',
    params: params
  })
}

//保存试卷某个试题答案信息接口（考试只能一直点下一题，不能切换到上一题）
export function saveTestQsInfo (params) {
  return request({
    url: '/api/wxpx/saveTestQsInfo',
    method: 'get',
    params: params
  })
}

// 获取试卷提交后的所有试题答案明细信息接口
export function getTestFinishInfo (params) {
  return request({
    url: '/api/wxpx/getTestFinishInfo',
    method: 'get',
    params: params
  })
}
// 获取待评价课程列表接口
export function getPjCourseList (params) {
  return request({
    url: '/api/wxpx/getPjCourseList',
    method: 'get',
    params: params
  })
}

// 获取初始的课程评价或讲师评价问卷信息列表
export function getPjDetail (params) {
  return request({
    url: '/api/wxpx/getPjDetail',
    method: 'get',
    params: params
  })
}

// 提交课程评价/讲师评价问卷信息列表
export function savePjDetail (data) {
  return request({
    url: '/api/wxpx/savePjDetail',
    method: 'post',
    data: data
  })
}

// 获取提交后的课程评价/讲师评价结果信息列表
export function getFinishPjDetail (params) {
  return request({
    url: '/api/wxpx/getFinishPjDetail',
    method: 'get',
    params: params
  })
}

// 获取待学习课程列表接口
export function getStudyCourseList (params) {
  const { empid } = params
  return request({
    url: '/api/wxpx/getStudyCourseList',
    method: 'get',
    params
  })
}

// 获取课程各阶段课件列表接口
export function getStepWareInfo (params) {

  return request({
    url: '/api/wxpx/getStepWareInfo',
    method: 'get',
    params: params
  })
}

// 保存观看课件记录日志接口
export function saveWatchLog (params) {
  const { empid, mautoid, cw_autoid, username } = params
  return request({
    url: '/api/wxpx/saveWatchLog',
    method: 'get',
    params: params
  })
}

// 获取当月有培训的日期列表
export function getSignDateList (params) {
  return request({
    url: '/api/wxpx/getSignDateList',
    method: 'get',
    params: params
  })
}

// 获取某天要培训课程详细信息列表
export function getSignCourseList (params) {
  return request({
    url: '/api/wxpx/getSignCourseList',
    method: 'get',
    params: params
  })
}

// 保存签到结果接口
export function saveSignRecord (params) {
  return request({
    url: '/api/wxpx/saveSignRecord',
    method: 'get',
    params: params
  })
}

// 保存签到结果接口
export function getSignEmpList (params) {
  return request({
    url: '/api/wxpx/getSignEmpList',
    method: 'get',
    params: params
  })
}


// 获取历史培训记录列表
export function getHisTrainRecordList (params) {
  return request({
    url: '/api/wxpx/getHisTrainRecordList',
    method: 'get',
    params: params
  })
}

// 获取历史培训记录列表
export function getTrainRecordInfo (params) {
  return request({
    url: '/api/wxpx/getTrainRecordInfo',
    method: 'get',
    params: params
  })
}

// 获取历史考试记录列表
export function getHisPostPaperList (params) {
  return request({
    url: '/api/wxpx/getHisPostPaperList',
    method: 'get',
    params: params
  })
}

// 首次打开视频或文档调用接口
export function saveWatchLogStart (params) {
  return request({
    url: '/api/wxpx/saveWatchLog_Start',
    method: 'get',
    params: params
  })
}

// 中途暂停或关闭页面调用的接口
export function saveWatchLogEnd (params) {
  return request({
    url: '/api/wxpx/saveWatchLog_End',
    method: 'get',
    params: params
  })
}

// 获取某个课件的上次观看断点位置接口
export function getVideoLastPos (params) {
  const { empid, mautoid, cw_autoid, username } = params
  return request({
    url: '/api/wxpx/getVideoLastPos',
    method: 'get',
    params: params
  })
}

// 判断课件是否学习完成接口
export function checkWareFinish (params) {
  const { empid, mautoid, cw_autoid, username } = params
  return request({
    url: '/api/wxpx/checkWareFinish',
    method: 'get',
    params: params
  })
}

// 7.8.1判断当前用户是否有权限打开该问卷以及返回是否已经提交该问卷
export function getCommPjStatus (data) {
  return request({
    url: '/api/wxpx/getCommPjStatus',
    method: 'get',
    params: data
  })
}

// 7.8.2获取问卷提交前的详细信息接口
export function getCommPjDetail (data) {
  return request({
    url: '/api/wxpx/getCommPjDetail',
    method: 'get',
    params: data
  })
}

// 7.8.3提交问卷接口
export function saveCommPjDetail (data) {
  return request({
    url: '/api/wxpx/saveCommPjDetail',
    method: 'post',
    data: data
  })
}

// 7.8.4获取提交后的问卷信息接口
export function getCommFinishPjDetail (data) {
  return request({
    url: '/api/wxpx/getCommFinishPjDetail',
    method: 'get',
    params: data
  })
}

// 获取培训项目详细信息接口：
export function getTrainPrjInfo (data) {
  return request({
    url: '/api/wxpx/getTrainPrjInfo',
    method: 'get',
    params: data
  })
}

// 点击报名接口：
export function prjReqCheck (data) {
  return request({
    url: '/api/wxpx/prjReqCheck',
    method: 'get',
    params: data
  })
}

// 点击报名接口：
export function getPreQsItemInfo (data) {
  return request({
    url: '/api/wxpx/getPreQsItemInfo',
    method: 'get',
    params: data
  })
}

// 获取问卷的详细信息
export function getAllCommFinishPjDetail (params) {
  return request({
    url: '/api/wxpx/getAllCommFinishPjDetail',
    method: 'get',
    params: params
  })
}

// 获取通用的考试试卷信息明细数据接口
export function getCommTestFinishInfo (params) {
  return request({
    url: '/api/wxpx/getCommTestFinishInfo',
    method: 'get',
    params: params
  })
}

// 结束当前考试并提交试卷的接口（当考试中途切换页面时调用）
export function autoPostPaper (params) {
  return request({
    url: '/api/wxpx/autoPostPaper',
    method: 'get',
    params: params
  })
}

// 获取某个试题的详细信息
export function getEmpTestQsDtInfo (params) {
  return request({
    url: '/api/wxpx/getEmpTestQsDtInfo',
    method: 'get',
    params: params
  })
}

// 结束当前考试并提交试卷的接口（当考试中途切换页面时调用）
export function postUserTestInfo (params) {
  return request({
    url: '/api/wxpx/postUserTestInfo',
    method: 'get',
    params: params
  })
}

// 保存培训请假状态接口
export function saveTrainLeave (params) {
  return request({
    url: '/api/wxpx/saveTrainLeave',
    method: 'get',
    params: params
  })
}

// 获取培训实施报名详情接口
export function getTrainImplReqInfo (params) {
  return request({
    url: '/api/wxpx/getTrainImplReqInfo',
    method: 'get',
    params: params
  })
}

// 培训实施点击确定报名接口
export function trainImplReqCheck (params) {
  return request({
    url: '/api/wxpx/trainImplReqCheck',
    method: 'get',
    params: params
  })
}


export function getStudyCourseInfo (params) {
  return request({
    url: '/api/wxpx/getStudyCourseInfo',
    method: 'get',
    params: params
  })
}

export function stopUserTest (params) {
  return request({
    url: '/api/wxpx/stopUserTest',
    method: 'get',
    params: params
  })
}

// 单点登录的阅卷界面所需信息
export function getSsoPaperTestAuditInfo (params) {
  return request({
    url: "/api/wxpx/getSsoPaperTestAuditInfo",
    method: "get",
    params
  });
}

// 单点登录的保存阅卷信息接口
export function saveEmpTestDetail (data) {
  return request({
    url: "/api/m487/saveEmpTestDetail",
    method: "post",
    data
  });
}

// 获取待阅卷列表
export function getForYjPaperList (params) {
  return request({
    url: "/api/wxpx/getForYjPaperList",
    method: "get",
    params
  });
}
